import { Button, Input } from "antd";
import { useNavigate } from "react-router-dom";
import ShebaFintechLayout from "../../../layouts/ShebaFintechLayout";

export default function ShebaFintechVerification() {
  const navigate = useNavigate();
  return (
    <>
      <ShebaFintechLayout>
        <div className="self-stretch text-center justify-center text-white text-sm font-medium font-['Inter'] leading-normal">
          Enter verification code sent to <br /> 017XXXXXX03
        </div>

        <div className="mt-3">
          <Input placeholder="Enter 6-digit code" type="number" />
        </div>

        <div className="mt-4 self-stretch text-center justify-center text-white text-sm font-medium font-['Inter'] leading-normal">
          Resend Code in 13s
        </div>

        <div className="flex justify-center items-center gap-3 mt-4">
          <Button
            onClick={() => navigate("/admin/sheba-pay-wallet")}
            className="w-[50%] self-stretch px-5 py-2.5 bg-cyan-600 text-white hover:!text-white uppercase rounded-md outline outline-1 outline-offset-[-1px] outline-cyan-400 inline-flex justify-center items-center gap-2.5"
          >
            Close
          </Button>
          <Button
            onClick={() =>
              navigate("/admin/sheba-pay-wallet/sheba-fintech/pin")
            }
            className="w-[50%] self-stretch px-5 py-2.5 bg-cyan-600 text-white hover:!text-white uppercase rounded-md outline outline-1 outline-offset-[-1px] outline-cyan-400 inline-flex justify-center items-center gap-2.5"
          >
            Confirm
          </Button>
        </div>
      </ShebaFintechLayout>
    </>
  );
}
